import React from 'react';
import {useRouter} from '../../../../../@casino/useRouter';
import {setGetViewReferrals} from '../../store/thunk/setGetViewReferral';
import {useDispatch, useSelector} from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import {getRows, columns} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    root: {
        padding: 30, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrapBlock: {
        padding: 10, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}))
const ViewReferral = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const router = useRouter();
    
    const [active, setActive] = React.useState('replenishment')
    const {promocode} = router.query;

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});


    React.useEffect(() => {
        dispatch(setGetViewReferrals({
            page: 1,
            rowsPerPage: 10,
            promocode,
            date_from: 0,
            date_to: new Date().getTime(),
            tag: 'replenishment'
        }))
    }, [promocode]);

    const referral = useSelector(state => state.referrals.view);
   
    const rows = React.useMemo(() => {
        if (referral) {
            return getRows(referral.data)
        }
    }, [referral]);

    return (
        <div className={classes.root}>
            <Title label={`Подробнее о ${promocode}`}/>
            <div className={classes.wrapBlock}>
            <FormikContext.Provider value={formik}>
                    <form>
                        <div style={{
                            paddingLeft: 20,
                            background: '#1b2039', 
                            borderRadius: 8, 
                        }}>
                            <div style={{display: 'flex', marginRight: 12}}>
                                <label htmlFor="check" className={classes.wrapSwitch}>
                                    <span className={classes.manually}>Ручн. время</span>
                                    <Switch
                                        checked={formik.values.check}
                                        onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                        color="primary"
                                        name="checkedB"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </label>
                                <span className={classes.spo}>С</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    className={classes.datetime}
                                    value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(0);
                                            date.setMinutes(0);
                                            date.setSeconds(0);
                                            date.setMilliseconds(0);
                                        }

                                        formik.setFieldValue('date_from', date.getTime());

                                        dispatch(setGetViewReferrals({
                                            page: 1,
                                            rowsPerPage: 10,
                                            tag: active,
                                            promocode,
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        }))
                                    }}
                                />
                                <span className={classes.spo}>ПО</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                    value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(23);
                                            date.setMinutes(59);
                                            date.setSeconds(59);
                                            date.setMilliseconds(999);
                                        }

                                        formik.setFieldValue('date_to', date.getTime());

                                        dispatch(setGetViewReferrals({
                                            page: 1, 
                                            rowsPerPage: 10,
                                            promocode,
                                            tag: active,
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                        }))
                                        
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
            <div style={{
                padding: '20px',
                background: '#1b2039',
                borderRadius: '8px',
                marginBottom: '12px',
            }}>
                <div style={{marginBottom: 20}}>
                    <span 
                        style={{margin: '0 30px 0 10px', textTransform: 'uppercase', fontSize: 18, cursor: 'pointer', color: active === 'replenishment' ? 'pink' : '#fff'}}
                        onClick={() => {
                            setActive('replenishment');
                            dispatch(setGetViewReferrals({
                                page: 1,
                                rowsPerPage: 10,
                                promocode,
                                date_from: 0,
                                date_to: new Date().getTime(),
                                tag: 'replenishment'
                            }))
                        }}
                        
                    >Пополнения</span>
                    <span 
                        style={{margin: '0 30px 0 0px', textTransform: 'uppercase', fontSize: 18, cursor: 'pointer', color: active === 'all' ? 'pink' : '#fff'}}
                        onClick={() => {
                            setActive('all');
                            dispatch(setGetViewReferrals({
                                page: 1,
                                rowsPerPage: 10,
                                promocode,
                                date_from: 0,
                                date_to: new Date().getTime(),
                                tag: 'all'
                            }))
                        }}
                    >Все</span>
                </div>
                <TableCasino 
                    pagination
                    allPage={referral.countPage}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows ? rows : []}
                    changePage={(v) => dispatch(setGetViewReferrals({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        promocode
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetViewReferrals({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        promocode
                    }))}
                />
            </div>
        </div>
    )
}

export default ViewReferral;